/* Shared buy-box behavior for mgn-main-shop and mgn-variant-shop */
(function () {
  'use strict';

  function readVariantImageMap(section) {
    var el = section.querySelector('[data-mgn-variant-image-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function parseDiscountCodes(raw) {
    var text = (raw || '').trim();
    if (!text) return [];
    return text.split(/[\n,]+/g).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function getPromoGiftItems(section) {
    if (section.dataset.customPromoEnabled !== 'true') return [];
    var landingSource = (section.dataset.customPromoLandingSource || '').trim();
    var rawIds = (section.dataset.customPromoGiftIds || '').trim();
    if (!landingSource || !rawIds) return [];
    return rawIds.split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (id) {
      return {
        id: Number(id),
        quantity: 1,
        properties: {
          _landing_source: landingSource,
          __landing_source: landingSource,
          _promo_gift: 'true',
        },
      };
    });
  }

  function attachPromoLandingSource(section, item) {
    if (section.dataset.customPromoEnabled !== 'true') return item;
    var landingSource = (section.dataset.customPromoLandingSource || '').trim();
    if (!landingSource) return item;
    var next = Object.assign({}, item);
    next.properties = Object.assign({}, item.properties || {}, {
      _landing_source: landingSource,
      __landing_source: landingSource,
    });
    return next;
  }

  function getSectionConfig(section) {
    return {
      bogoUrlParamsEnabled: section.dataset.bogoUrlParamsEnabled === 'true',
      bogoUrlParams: section.dataset.bogoUrlParams || '',
      checkoutUrl: section.dataset.checkoutUrl || '/checkout',
      giftCardAttrSubEnabled: section.dataset.giftCardAttrSubEnabled === 'true',
      giftCardAttrOtpEnabled: section.dataset.giftCardAttrOtpEnabled === 'true',
      giftCardAmount: section.dataset.giftCardAttrAmount || '',
    };
  }

  function applyBogoUrlParams(sectionConfig, options) {
    if (!window.AmbrosiaBogoUrlParams) return false;
    return window.AmbrosiaBogoUrlParams.apply(sectionConfig, options);
  }

  function initMgnShop(section) {
    if (!section || section.dataset.mgnShopBound === 'true') return;
    section.dataset.mgnShopBound = 'true';

    var sectionConfig = getSectionConfig(section);
    var mgnVariantImageMap = readVariantImageMap(section);

    var purchaseDiv = section.querySelector('.mgn-main-shop__purchase');
    var optionCards = section.querySelectorAll('[data-mgn-option]');
    var planInput = section.querySelector('.mgn-main-shop__selling-plan');
    var unlockedFreebies = section.querySelector('.mgn-main-shop__unlocked');

    var subVariantId = section.dataset.subVariantId;
    var otpVariantId = section.dataset.otpVariantId || subVariantId;
    var variantIdInput = section.querySelector('.mgn-main-shop__form input[name="id"]');
    var otpImageUrl = section.dataset.otpImage || null;
    var subscriptionOnly = purchaseDiv && purchaseDiv.dataset.subscriptionOnly === 'true';

    var mainGallerySlider = section.querySelector('#mainProduct-gallery');
    var firstSlideImg = section.querySelector('#mainProduct-gallery .swiper-slide:first-child img');
    var firstThumbImg = section.querySelector('#mainProduct-thumbs .swiper-slide:first-child img');
    var originalSlideImgSrc = firstSlideImg ? firstSlideImg.src : null;
    var originalThumbImgSrc = firstThumbImg ? firstThumbImg.src : null;

    var variantButtons = section.querySelectorAll('[data-mgn-variant-id]');
    var variantDropdown = section.querySelector('.mgn-main-shop__variant-select-dropdown');
    var variantDropdownOptions = section.querySelectorAll('[data-mgn-variant-option]');
    var variantTrigger = section.querySelector('[data-mgn-variant-trigger]');
    var variantTriggerLabel = section.querySelector('.mgn-main-shop__variant-select-trigger-label');

    var currentVariantId = String(subVariantId || '');

    if (applyBogoUrlParams(sectionConfig, { allowReload: true })) return;

    if (otpImageUrl) { new Image().src = otpImageUrl; }
    if (originalSlideImgSrc) { new Image().src = originalSlideImgSrc; }

    function slideMainGalleryToFirst() {
      if (mainGallerySlider && mainGallerySlider.swiperInstance) {
        mainGallerySlider.swiperInstance.slideTo(0, 0);
        return true;
      }
      return false;
    }

    function ensureMainGallerySlideToFirst() {
      if (slideMainGalleryToFirst()) return;
      var attempts = 0;
      var id = setInterval(function () {
        attempts += 1;
        if (slideMainGalleryToFirst() || attempts > 50) clearInterval(id);
      }, 50);
    }

    function getPurchaseType() {
      return purchaseDiv && purchaseDiv.getAttribute('data-purchase-type') === 'otp' ? 'otp' : 'sub';
    }

    function updateHeroImage() {
      if (!firstSlideImg) return;

      var purchaseType = getPurchaseType();
      var variantKey = String(currentVariantId || subVariantId || '');
      var variantImages = mgnVariantImageMap[variantKey] || {};
      var targetUrl = null;

      if (purchaseType === 'sub') {
        targetUrl = variantImages.sb || originalSlideImgSrc;
      } else {
        targetUrl = variantImages.ot || otpImageUrl || originalSlideImgSrc;
      }

      if (!targetUrl) return;

      firstSlideImg.src = targetUrl;
      firstSlideImg.removeAttribute('srcset');

      if (firstThumbImg) {
        firstThumbImg.src = targetUrl;
        firstThumbImg.removeAttribute('srcset');
      }

      ensureMainGallerySlideToFirst();
    }

    function selectVariant(variantId) {
      if (!variantIdInput) return;

      var clicked = section.querySelector('[data-mgn-variant-id="' + variantId + '"], [data-mgn-variant-option="' + variantId + '"]');
      if (clicked && clicked.getAttribute('data-available') === 'false') return;

      variantButtons.forEach(function (btn) {
        var isActive = btn.dataset.mgnVariantId === String(variantId);
        btn.classList.toggle('is-selected', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      var activeDropdownOption = null;
      variantDropdownOptions.forEach(function (btn) {
        var isActive = btn.dataset.mgnVariantOption === String(variantId);
        btn.classList.toggle('is-selected', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) activeDropdownOption = btn;
      });

      if (variantTriggerLabel && activeDropdownOption) {
        variantTriggerLabel.innerHTML = activeDropdownOption.innerHTML;
      }

      var isSub = purchaseDiv && purchaseDiv.getAttribute('data-purchase-type') === 'sub';
      currentVariantId = String(variantId);

      if (isSub) {
        variantIdInput.value = String(variantId);
        subVariantId = String(variantId);
      }

      updateHeroImage();
      clearCartError();
    }

    function selectPurchaseOption(type) {
      if (subscriptionOnly && type === 'otp') return;

      optionCards.forEach(function (card) {
        var isThis = card.dataset.mgnOption === type;
        card.classList.toggle('is-selected', isThis);
        card.setAttribute('aria-checked', isThis ? 'true' : 'false');
      });
      if (purchaseDiv) purchaseDiv.setAttribute('data-purchase-type', type);
      if (planInput) {
        var planId = planInput.getAttribute('data-plan-id');
        if (type === 'sub' && planId) {
          planInput.setAttribute('name', 'selling_plan');
          planInput.value = planId;
          if (unlockedFreebies) unlockedFreebies.style.display = 'block';
        } else {
          planInput.removeAttribute('name');
          if (unlockedFreebies) unlockedFreebies.style.display = 'none';
        }
      }
      if (variantIdInput) {
        if (variantButtons.length) {
          // Main shop: keep current flavor for sub, otp product for one-time
          variantIdInput.value = (type === 'otp') ? otpVariantId : (currentVariantId || subVariantId);
        } else {
          // Variant shop: fixed sub/otp variant IDs
          variantIdInput.value = (type === 'otp') ? otpVariantId : subVariantId;
        }
      }
      updateHeroImage();
    }

    optionCards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectPurchaseOption(this.dataset.mgnOption);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPurchaseOption(this.dataset.mgnOption);
        }
      });
    });

    variantButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariant(this.dataset.mgnVariantId);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectVariant(this.dataset.mgnVariantId);
        }
      });
    });

    if (variantDropdown && variantTrigger) {
      variantTrigger.addEventListener('click', function () {
        var open = !variantDropdown.hasAttribute('hidden');
        if (open) {
          variantDropdown.setAttribute('hidden', '');
          variantTrigger.setAttribute('aria-expanded', 'false');
        } else {
          variantDropdown.removeAttribute('hidden');
          variantTrigger.setAttribute('aria-expanded', 'true');
        }
      });

      variantDropdownOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectVariant(this.dataset.mgnVariantOption);
          variantDropdown.setAttribute('hidden', '');
          variantTrigger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    var checkoutWrap = section.querySelector('.mgn-main-shop__form');
    var checkoutBtn = section.querySelector('[data-mgn-checkout-cta]');
    var cartErrorEl = section.querySelector('[data-mgn-cart-error]');

    function clearCartError() {
      if (!cartErrorEl) return;
      cartErrorEl.textContent = '';
      cartErrorEl.setAttribute('hidden', '');
    }

    function showCartError(message) {
      if (!cartErrorEl) return;
      cartErrorEl.textContent = message || 'Unable to add to cart. Please try again.';
      cartErrorEl.removeAttribute('hidden');
    }

    if (checkoutWrap && checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        clearCartError();
        applyBogoUrlParams(sectionConfig);

        var ctaLabelEl = checkoutBtn.querySelector('[data-mgn-cta-label]');
        var ctaLabel = ctaLabelEl ? ctaLabelEl.textContent.trim() : 'Checkout';
        checkoutBtn.disabled = true;
        if (ctaLabelEl) ctaLabelEl.textContent = 'Adding products to cart…';

        var variantId = Number(checkoutWrap.querySelector('input[name="id"]').value);
        var qty = Number(checkoutWrap.querySelector('input[name="quantity"]').value) || 1;
        var spInput = checkoutWrap.querySelector('.mgn-main-shop__selling-plan');
        var sellingPlan = (spInput && spInput.getAttribute('name')) ? Number(spInput.value) : null;

        var mainItem = attachPromoLandingSource(section, { id: variantId, quantity: qty });
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        var isSub = purchaseDiv && purchaseDiv.getAttribute('data-purchase-type') === 'sub';
        var discountCodes = isSub ? parseDiscountCodes(section.dataset.discountCode || '') : [];
        var shouldClearCart = section.dataset.clearCart !== 'false';
        var items = [mainItem];
        if (isSub) {
          var discountData = [];
          try { discountData = JSON.parse(section.dataset.discountBlocks || '[]'); } catch (_) {}
          discountData.forEach(function (d) {
            if (d.variant_id) {
              items.push({ id: Number(d.variant_id), quantity: 1 });
            }
          });
        }
        getPromoGiftItems(section).forEach(function (g) { items.push(g); });

        function resetSubmitBtn() {
          checkoutBtn.disabled = false;
          if (ctaLabelEl) ctaLabelEl.textContent = ctaLabel;
          if (window.AmbrosiaFastCheckout) window.AmbrosiaFastCheckout.endRedirecting();
        }

        if (!window.AmbrosiaFastCheckout) {
          console.error('Checkout helper failed to load');
          showCartError('Checkout helper failed to load. Please refresh and try again.');
          resetSubmitBtn();
          return;
        }

        window.AmbrosiaFastCheckout.addThenCheckout({
          sectionConfig: sectionConfig,
          clearCart: shouldClearCart,
          items: items,
          fallbackItems: [mainItem],
          waitForGift: sectionConfig.bogoUrlParamsEnabled,
          isSubscription: isSub,
          extraAttributes: isSub ? { _offer_source: 'planta_starter_kit_ship50' } : null,
          discountCodes: discountCodes,
        }).catch(function (err) {
          console.error(err);
          showCartError(err && err.message ? err.message : 'Unable to add to cart. Please try again.');
          resetSubmitBtn();
        });
      });
    }

    var faqList = section.querySelector('.mgn-main-shop__faq-list');
    if (faqList) {
      var faqItems = faqList.querySelectorAll('[data-mgn-faq-item]');
      var triggers = faqList.querySelectorAll('[data-mgn-faq-trigger]');

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = this.closest('[data-mgn-faq-item]');
          var panel = item.querySelector('.mgn-main-shop__faq-panel');
          var isOpen = item.classList.contains('mgn-main-shop__faq-item--open');

          if (isOpen) {
            item.classList.remove('mgn-main-shop__faq-item--open');
            this.setAttribute('aria-expanded', 'false');
            if (panel) panel.setAttribute('aria-hidden', 'true');
          } else {
            faqItems.forEach(function (other) {
              other.classList.remove('mgn-main-shop__faq-item--open');
              var otherBtn = other.querySelector('[data-mgn-faq-trigger]');
              var otherPanel = other.querySelector('.mgn-main-shop__faq-panel');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
            });
            item.classList.add('mgn-main-shop__faq-item--open');
            this.setAttribute('aria-expanded', 'true');
            if (panel) panel.setAttribute('aria-hidden', 'false');
          }
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-mgn-shop]').forEach(initMgnShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-mgn-shop]')
      : null;
    if (root) {
      root.dataset.mgnShopBound = 'false';
      initMgnShop(root);
    }
  });
})();
